import { Icon } from '@/core/icon';
import { Button, Typography } from '@/core/ui';
import { cn } from '@/lib/utils';
import { useAppDispatch } from '@/store';
import { setCompetitionId } from '@/store/cups';

interface IProps extends React.ComponentProps<'div'> {
  name: string;
  link: boolean;
  competitionId: number;
  logo: string;
}

export const CompetitionCard = ({ name, competitionId, logo, link, className }: IProps) => {
  const dispatch = useAppDispatch();

  const onClick = () => {
    dispatch(setCompetitionId(competitionId));
  };

  return (
    <div
      className={cn(
        'flex flex-row space-x-[14px] items-center relative overflow-hidden',
        'w-[290px] h-[108px] rounded-[17px] px-[15px] py-[19px]',
        'bg-apple',
        className,
      )}
    >
      <img src={logo} alt='' className='w-[4.5rem] h-[4.5rem] object-cover' />

      <div className='flex flex-col h-full items-center justify-center'>
        <Typography
          className={cn('text-content1 text-[16px] leading-[16px] uppercase font-semibold line-clamp-4', {
            'w-[100px]': link,
            'w-[110px]': !link,
          })}
        >
          {name}
        </Typography>
      </div>
      {link && (
        <Button
          onClick={onClick}
          className='absolute hover:bg-olive shadow-none border-none right-0 w-[77px] h-full rounded-l-none rounded-r-[18px] bg-olive flex justify-center items-center'
        >
          <Icon name='PLUS_CIRCLE' className='w-16 h-16 scale-[1.7]' />
        </Button>
      )}
    </div>
  );
};
